const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '全网最快爆料',
    desc: '7×24小时不间断追踪各大平台热点，爆料速度领跑同行，让你永远快人一步吃到最新鲜的瓜。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '有图有真相',
    desc: '所有爆料内容均经过多源交叉验证，配备截图、视频等实锤证据，杜绝编造和虚假信息传播。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端无缝体验',
    desc: '网站与APP数据实时同步，无论身处何地都能随时刷最新爆料，真正实现不打烊的吃瓜体验。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          为什么选择我们<i className="ri-star-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">91黑料的核心优势</p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((f) => (
            <article key={f.id} className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center group hover:border-primary-200/50 transition-colors">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200/80 transition-colors">
                <i className={`${f.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="mt-4 text-base font-heading font-bold text-foreground-900">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}